import type { StateCreator } from 'zustand';

import type { AuthSlice, Slices } from './types';

export const createAuthSlice: StateCreator<Slices, [], [], AuthSlice> = (set) => ({
  auth: {
    // Every boot starts here and leaves only when `POST /auth/refresh` answers.
    // A guard that redirected during this window would bounce a hard refresh on
    // /room/:id to the login screen (frontend.md §1.1).
    status: 'hydrating',
    user: null,
    accessToken: null,

    setSession: ({ accessToken, user }) => {
      set((s) => ({ auth: { ...s.auth, status: 'authenticated', accessToken, user } }));
    },

    setUser: (user) => {
      set((s) => ({ auth: { ...s.auth, user } }));
    },

    clear: () => {
      set((s) => ({ auth: { ...s.auth, status: 'anonymous', accessToken: null, user: null } }));
    },

    markAnonymous: () => {
      set((s) =>
        s.auth.status === 'hydrating' ? { auth: { ...s.auth, status: 'anonymous' } } : s,
      );
    },
  },
});
